export default {"src":"/_next/static/media/left-arrow.cc4ac58a.svg","height":20,"width":21};